// ANCHOR React
import { useCallback } from 'react';

// ANCHOR Base
import { styled } from 'baseui';

// ANCHOR Models
import { CourseCardData } from '@lyon/scoped-models/CourseCardData';

// ANCHOR Results
import { ICourseResult, ApprovalStatus } from '@lyon/utils/api/results/course';

// ANCHOR Graph States
import { useAuthAdmin } from '@lyon/nodes/firebase/auth/auth-admin-node';

// ANCHOR Utils
import { convertToSlug } from '@lyon/utils/extras/convertToSlug';
import { track } from '@lyon/utils/segment';
import { ucarecdn } from '@lyon/utils/ucarecdn';

// ANCHOR Components
import { LyonLink } from '@lyon/components/utils/LyonLink';
import { LyonCourseCardContainer } from './LyonCourseCardContainer';

interface IProps {
  course?: ICourseResult;
  fromProvider?: boolean;
  hasAvatar?: boolean;
  myCourse?: boolean;
  approvalStatus?: ApprovalStatus;
  isProviderManager?: boolean;
}

const ClickableDiv = styled('div', {
  background: 'none',
});

export function LyonCourseCardRevision({
  course,
  hasAvatar = true,
  fromProvider = false,
  myCourse = false,
  isProviderManager = false,
  approvalStatus,
}: IProps) {
  const isAdmin = useAuthAdmin();

  const onClick = useCallback(() => {
    if (!isProviderManager && course) {
      track('Product Clicked', {
        productId: course.id,
        name: course.title,
        price: course.price,
        imageUrl: course.courseDisplayPhotoUuid
          ? ucarecdn(course.courseDisplayPhotoUuid)
          : undefined,
        url: `https://lyon.com.ph/course/${course.id}/${convertToSlug(course.title)}`,
      }, isAdmin, {
        context: {
          groupId: course?.providerId,
        },
      });
    }
  }, [course, isAdmin, isProviderManager]);

  return (
    <CourseCardData.Provider
      data={course}
      hasAvatar={hasAvatar}
      fromProvider={fromProvider}
      myCourse={myCourse}
      approvalStatus={approvalStatus}
    >
      {
        course?.id
          ? (
            <ClickableDiv onClick={onClick}>
              <LyonLink href={`/course/${course.id}/${convertToSlug(course.title)}${isProviderManager ? '/manage' : ''}`}>
                <LyonCourseCardContainer />
              </LyonLink>
            </ClickableDiv>
          )
          : <LyonCourseCardContainer />
      }
    </CourseCardData.Provider>
  );
}
